import { ComponentProps } from "react";
import { TrustpilotStars } from "@airhelp/badges";
import { TrustPilot } from "@airhelp/icons";
import { Flex, Text, Link, HStack } from "@chakra-ui/react";
import useTrustpilotScore from "api/react-query-hooks/useTrustpilotScore";
import { DEFAULT_TRUSTPILOT_SCORE } from "api/trustpilotScore";
import { useTranslation } from "react-i18next";
import { useAppSettings } from "app-settings/AppSettingsContext";

export function FunnelTrustpilot({ className, ...props }: TrustpilotProps) {
  const { locale } = useAppSettings();
  const {
    data: {
      scoreValue = DEFAULT_TRUSTPILOT_SCORE.scoreValue,
      totalReviews = DEFAULT_TRUSTPILOT_SCORE.totalReviews,
      trustpilotLink = DEFAULT_TRUSTPILOT_SCORE.trustpilotLink,
    },
  } = useTrustpilotScore(locale);
  const { t } = useTranslation();

  const formatThousands = (value: string) => {
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <Link href={trustpilotLink} target="_blank" rel="noopener">
      <Flex
        align="center"
        className={className}
        data-testid="funnel-trustpilot"
        flexWrap="wrap"
        justifyContent={{ base: "center", md: "flex-start" }}
        rowGap={2}
        {...props}
      >
        <HStack
          align="center"
          justifyContent="center"
          data-testid="trustpilot-excellent"
          sx={{
            svg: {
              width: 109,
              height: 22,
            },
          }}
          mr={4}
        >
          <TrustpilotStars
            starLabelText={t("footer.trustpilot.excellent")}
            numberOfStars={scoreValue}
            isLogoHidden
          />
        </HStack>

        <HStack gap={0}>
          <Text fontSize="sm" fontWeight="bold" color="primary.900" mr={1}>
            {formatThousands(totalReviews.toString())}
          </Text>
          <Text fontSize="sm" color="primary.900">
            {t("footer.trustpilot.reviews_on")}
          </Text>
          <TrustPilot ml={2} w={5} h={5} />
          <Text fontSize="sm" fontWeight="bold" color="primary.900">
            Trustpilot
          </Text>
        </HStack>
      </Flex>
    </Link>
  );
}

type TrustpilotProps = ComponentProps<typeof Flex> & {
  className?: string;
};
